import { Component } from '@angular/core';

@Component({
  selector: 'modal-placeholder',
  imports: [],
  templateUrl: './modal-placeholder.component.html',
  styleUrl: './modal-placeholder.component.scss'
})
export class ModalPlaceholderComponent {

}
